import React, { Component } from 'react';
import Header from './../components/Header';
import About from './../components/About';
import Partners from './../components/Partners';

class AboutUsPage extends Component {
  render() {
    return (
      <div>
        <Header />
        <About />
        <Partners />
      </div>
    );
  }
}

export default AboutUsPage;
